import { View, useWindowDimensions } from 'react-native'
import { screens } from '@chillout/core'
import type { MemberStampData } from './useMemberStampData'
import { AvailableRewardsSection } from './AvailableRewardsSection'
import { RecentActivitySection } from './RecentActivitySection'

interface MemberStampDataSectionProps {
  stampData: MemberStampData
}

export function MemberStampDataSection({ stampData }: MemberStampDataSectionProps) {
  const { width } = useWindowDimensions()
  const twoColumn = width >= screens.lg

  const hasRewards = stampData.availableRewards.length > 0
  const hasActivity = stampData.recentActivity.length > 0

  if (!hasRewards && !hasActivity) return null

  if (twoColumn && hasRewards && hasActivity) {
    return (
      <View style={{ flexDirection: 'row', gap: 24 }}>
        <View style={{ flex: 1 }}>
          <AvailableRewardsSection rewards={stampData.availableRewards} />
        </View>
        <View style={{ flex: 1 }}>
          <RecentActivitySection transactions={stampData.recentActivity} />
        </View>
      </View>
    )
  }

  if (twoColumn && hasActivity) {
    return (
      <View style={{ flexDirection: 'row', gap: 24 }}>
        <View style={{ flex: 1 }}>
          <RecentActivitySection transactions={stampData.recentActivity} />
        </View>
        <View style={{ flex: 1 }} />
      </View>
    )
  }

  return (
    <View className="gap-6">
      {hasRewards && <AvailableRewardsSection rewards={stampData.availableRewards} />}
      {hasActivity && <RecentActivitySection transactions={stampData.recentActivity} />}
    </View>
  )
}